export interface AnimeItem {
  id: string;
  title: string;
  tags: string[];
  score: number;
  season: string;
  image: string;
  desc: string;
}

export interface CategoryItem {
  id: string;
  name: string;
  en: string;
  count: string;
  icon: string;
  image: string;
  desc: string;
}

export interface ReviewItem {
  id: string;
  title: string;
  date: string;
  category: string;
  readTime: string;
  excerpt: string;
  image: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const newSeason: AnimeItem[] = [
  {
    id: "new-1",
    title: "星海旅人的黄昏",
    tags: ["奇幻", "冒险", "旅行"],
    score: 9.2,
    season: "本季新番",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20young%20traveler%20standing%20on%20a%20starry%20cliff%20at%20twilight%2C%20glowing%20constellations%20in%20deep%20night%20sky%2C%20warm%20amber%20and%20crimson%20light%2C%20cinematic%20composition%2C%20detailed%20illustration&width=900&height=1200&seq=anime-new-01&orientation=portrait",
    desc: "少女与神秘旅伴踏上横跨星海的旅程，在黄昏与黎明之间寻找失落的故土。",
  },
  {
    id: "new-2",
    title: "剑与焰的协奏曲",
    tags: ["战斗", "热血", "奇幻"],
    score: 8.8,
    season: "本季新番",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20swordsman%20wielding%20a%20flaming%20blade%20against%20dark%20background%2C%20embers%20and%20sparks%20flying%2C%20dramatic%20crimson%20and%20orange%20lighting%2C%20dynamic%20action%20pose%2C%20detailed%20illustration&width=900&height=1200&seq=anime-new-02&orientation=portrait",
    desc: "落魄剑士为守护伙伴重燃焰之剑，在阴谋与战火中奏响复仇与羁绊的协奏曲。",
  },
  {
    id: "new-3",
    title: "雾之都的侦探手记",
    tags: ["悬疑", "推理", "都市"],
    score: 9.0,
    season: "本季新番",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20detective%20in%20a%20long%20coat%20walking%20through%20foggy%20rainy%20city%20street%20at%20night%2C%20neon%20warm%20lights%20reflecting%20on%20wet%20ground%2C%20moody%20atmosphere%2C%20cinematic%20illustration&width=900&height=1200&seq=anime-new-03&orientation=portrait",
    desc: "浓雾笼罩的港都接连发生离奇事件，冷静的侦探在迷雾中抽丝剥茧寻找真相。",
  },
  {
    id: "new-4",
    title: "春日食堂的来信",
    tags: ["治愈", "日常", "美食"],
    score: 9.4,
    season: "本季新番",
    image: "https://readdy.ai/api/search-image?query=cozy%20anime%20key%20visual%20of%20a%20warm%20little%20restaurant%20interior%20with%20steaming%20food%20on%20wooden%20table%2C%20soft%20morning%20sunlight%20through%20window%2C%20cherry%20blossoms%20outside%2C%20heartwarming%20gentle%20atmosphere%2C%20detailed%20illustration&width=900&height=1200&seq=anime-new-04&orientation=portrait",
    desc: "开在春日街角的温馨食堂，用一道料理治愈每一位疲惫过客的心事与回忆。",
  },
  {
    id: "new-5",
    title: "机械之心重启",
    tags: ["科幻", "机甲", "青春"],
    score: 8.6,
    season: "本季新番",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20sleek%20white%20and%20crimson%20mecha%20robot%20standing%20in%20a%20futuristic%20hangar%2C%20blueprint%20glow%20lights%2C%20a%20young%20pilot%20silhouette%20in%20front%2C%20sci-fi%20atmosphere%2C%20detailed%20illustration&width=900&height=1200&seq=anime-new-05&orientation=portrait",
    desc: "被废弃的旧式机甲因少女的呼唤重新启动，青春与记忆在钢铁躯壳中苏醒。",
  },
  {
    id: "new-6",
    title: "云端上的乐队",
    tags: ["音乐", "青春", "成长"],
    score: 8.9,
    season: "本季新番",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20four%20teenage%20band%20members%20with%20instruments%20standing%20on%20a%20stage%20against%20sunset%20clouds%2C%20confetti%20and%20light%20beams%2C%20warm%20golden%20and%20crimson%20tones%2C%20energetic%20atmosphere%2C%20detailed%20illustration&width=900&height=1200&seq=anime-new-06&orientation=portrait",
    desc: "四个怀揣音乐梦想的高中生组建乐队，在云端舞台奏响属于青春的旋律。",
  },
];

export const topRank: AnimeItem[] = [
  {
    id: "top-1",
    title: "白夜行者的终章",
    tags: ["剧情", "深刻", "文学改编"],
    score: 9.6,
    season: "口碑神作",
    image: "https://readdy.ai/api/search-image?query=mature%20anime%20key%20visual%20of%20two%20silhouettes%20walking%20in%20opposite%20directions%20in%20a%20dim%20white%20night%20corridor%2C%20soft%20moonlight%2C%20poetic%20and%20melancholic%20mood%2C%20minimalist%20cinematic%20composition%2C%20detailed%20illustration&width=900&height=1200&seq=anime-top-01&orientation=portrait",
    desc: "两个被命运捆绑的灵魂在漫长黑夜中互相守望，关于救赎与抉择的文学级群像。",
  },
  {
    id: "top-2",
    title: "萤火之森再访",
    tags: ["治愈", "恋爱", "夏日"],
    score: 9.5,
    season: "口碑神作",
    image: "https://readdy.ai/api/search-image?query=gentle%20anime%20key%20visual%20of%20a%20summer%20forest%20with%20fireflies%20glowing%20gold%20and%20green%2C%20a%20boy%20and%20girl%20silhouettes%20under%20tall%20trees%2C%20warm%20dappled%20sunlight%2C%20nostalgic%20peaceful%20atmosphere%2C%20detailed%20illustration&width=900&height=1200&seq=anime-top-02&orientation=portrait",
    desc: "每年夏天在萤火森林重逢的约定，一段温柔又带着淡淡遗憾的夏日物语。",
  },
  {
    id: "top-3",
    title: "鲸落之海",
    tags: ["奇幻", "治愈", "自然"],
    score: 9.3,
    season: "口碑神作",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20giant%20whale%20swimming%20through%20a%20starry%20ocean%20sky%2C%20bioluminescent%20teal%20and%20gold%20particles%2C%20a%20small%20child%20riding%20on%20top%2C%20ethereal%20dreamlike%20composition%2C%20detailed%20illustration&width=900&height=1200&seq=anime-top-03&orientation=portrait",
    desc: "鲸落滋养深海，也为少年带来跨越生死的成长。一场关于生命循环的浪漫奇旅。",
  },
  {
    id: "top-4",
    title: "黄昏下的信使",
    tags: ["剧情", "历史", "群像"],
    score: 9.1,
    season: "口碑神作",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20messenger%20riding%20a%20bicycle%20through%20old%20town%20streets%20at%20sunset%2C%20delivering%20letters%2C%20warm%20amber%20lanterns%20and%20shadows%2C%20nostalgic%20cinematic%20mood%2C%20detailed%20illustration&width=900&height=1200&seq=anime-top-04&orientation=portrait",
    desc: "在战乱年代坚持送信的少年信使，用一封封信件串起普通人的悲欢与坚守。",
  },
];

export const categories: CategoryItem[] = [
  {
    id: "cat-1",
    name: "热血战斗",
    en: "Action",
    count: "328 部",
    icon: "ri-fire-line",
    image: "https://readdy.ai/api/search-image?query=anime%20action%20category%20illustration%20with%20a%20hero%20punching%20flames%2C%20dynamic%20energy%20burst%2C%20crimson%20and%20orange%20palette%2C%20dramatic%20motion%20lines%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-action&orientation=landscape",
    desc: "燃烧的羁绊与不屈的意志，热血与成长交织的冒险篇章。",
  },
  {
    id: "cat-2",
    name: "治愈日常",
    en: "Slice of Life",
    count: "412 部",
    icon: "ri-sun-line",
    image: "https://readdy.ai/api/search-image?query=cozy%20anime%20category%20illustration%20of%20a%20quiet%20room%20with%20warm%20sunlight%2C%20cup%20of%20tea%20and%20books%2C%20soft%20cream%20and%20gold%20tones%2C%20peaceful%20gentle%20atmosphere%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-heal&orientation=landscape",
    desc: "藏在柴米油盐与日常小事里的温柔，治愈每一颗疲惫的心。",
  },
  {
    id: "cat-3",
    name: "奇幻冒险",
    en: "Fantasy",
    count: "296 部",
    icon: "ri-compass-3-line",
    image: "https://readdy.ai/api/search-image?query=anime%20fantasy%20category%20illustration%20of%20a%20floating%20island%20with%20castle%20and%20waterfall%2C%20mythical%20creatures%2C%20teal%20sky%20with%20golden%20light%2C%20epic%20exploration%20mood%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-fantasy&orientation=landscape",
    desc: "异世界与传说的交汇之地，展开一场又一场不可思议的冒险。",
  },
  {
    id: "cat-4",
    name: "悬疑推理",
    en: "Mystery",
    count: "178 部",
    icon: "ri-search-eye-line",
    image: "https://readdy.ai/api/search-image?query=anime%20mystery%20category%20illustration%20of%20a%20shadowy%20detective%20office%20with%20mysterious%20documents%20and%20magnifying%20glass%2C%20moody%20low%20light%2C%20deep%20green%20and%20gold%20tones%2C%20suspenseful%20atmosphere%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-mystery&orientation=landscape",
    desc: "迷雾重重下的蛛丝马迹，真相藏在每一个被忽略的细节里。",
  },
  {
    id: "cat-5",
    name: "科幻机甲",
    en: "Sci-Fi",
    count: "204 部",
    icon: "ri-robot-line",
    image: "https://readdy.ai/api/search-image?query=anime%20sci-fi%20category%20illustration%20of%20a%20giant%20mecha%20in%20a%20futuristic%20city%20at%20dusk%2C%20glowing%20circuit%20lights%2C%20teal%20and%20crimson%20accents%2C%20technological%20awe%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-scifi&orientation=landscape",
    desc: "钢铁与代码的浪漫，在星际之间追问人类与机器的边界。",
  },
  {
    id: "cat-6",
    name: "恋爱青春",
    en: "Romance",
    count: "386 部",
    icon: "ri-heart-3-line",
    image: "https://readdy.ai/api/search-image?query=anime%20romance%20category%20illustration%20of%20two%20students%20under%20a%20cherry%20blossom%20tree%20in%20spring%2C%20falling%20petals%2C%20soft%20pink%20and%20warm%20gold%20tones%2C%20sweet%20youthful%20mood%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-romance&orientation=landscape",
    desc: "青涩悸动的心跳与难以言说的告白，属于青春的最好年华。",
  },
  {
    id: "cat-7",
    name: "音乐偶像",
    en: "Music",
    count: "142 部",
    icon: "ri-music-2-line",
    image: "https://readdy.ai/api/search-image?query=anime%20music%20category%20illustration%20of%20a%20stage%20with%20colorful%20spotlights%20and%20silhouetted%20idols%2C%20floating%20musical%20notes%2C%20vibrant%20warm%20stage%20lighting%2C%20energetic%20concert%20mood%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-music&orientation=landscape",
    desc: "舞台灯光下的汗水与梦想，用歌声和舞步点燃全场。",
  },
  {
    id: "cat-8",
    name: "经典怀旧",
    en: "Classics",
    count: "256 部",
    icon: "ri-film-line",
    image: "https://readdy.ai/api/search-image?query=retro%20anime%20category%20illustration%20of%20a%20vintage%20cassette%20and%20tv%20on%20a%20wooden%20desk%2C%20nostalgic%20warm%20film%20grain%2C%20amber%20and%20sepia%20tones%2C%20childhood%20memory%20mood%2C%20detailed%20anime%20art&width=800&height=600&seq=cat-classic&orientation=landscape",
    desc: "跨越时代的经典之作，承载几代人共同记忆的珍贵时光。",
  },
];

export const reviews: ReviewItem[] = [
  {
    id: "rv-1",
    title: "《白夜行者的终章》：不是爽番，而是一场漫长的告别",
    date: "2026-08-16",
    category: "深度评测",
    readTime: "12 分钟",
    excerpt: "当追完一整季的感动逐渐沉淀，我们才意识到这部作品真正在讲述的，从来不是复仇，而是两个灵魂如何在黑暗中并肩前行。",
    image: "https://readdy.ai/api/search-image?query=moody%20anime%20review%20banner%20of%20two%20silhouettes%20at%20dusk%20with%20moonlight%2C%20poetic%20melancholic%20tone%2C%20deep%20blue%20night%20and%20warm%20amber%20contrast%2C%20cinematic%20illustration&width=800&height=500&seq=review-01&orientation=landscape",
  },
  {
    id: "rv-2",
    title: "2026 夏季新番第一波追番清单：这 10 部不容错过",
    date: "2026-08-12",
    category: "追番指南",
    readTime: "8 分钟",
    excerpt: "从奇幻冒险到治愈日常，我们为你精选了本季最值得期待的十部作品，附上首播评分与观看平台指引，帮你高效避雷。",
    image: "https://readdy.ai/api/search-image?query=anime%20guide%20banner%20with%20a%20calendar%20and%20multiple%20anime%20poster%20fragments%2C%20summer%20vibe%20with%20fireworks%2C%20vibrant%20warm%20tones%2C%20clean%20energetic%20composition%2C%20illustration&width=800&height=500&seq=review-02&orientation=landscape",
  },
  {
    id: "rv-3",
    title: "《春日食堂的来信》：用一道料理，治愈整个夏天",
    date: "2026-08-08",
    category: "治愈推荐",
    readTime: "6 分钟",
    excerpt: "没有跌宕的剧情，只有一道道家常菜和一个个过客的故事。它不急着讲道理，却在平凡里悄悄抚平了你的疲惫。",
    image: "https://readdy.ai/api/search-image?query=cozy%20anime%20review%20banner%20of%20a%20steaming%20bowl%20of%20ramen%20on%20a%20wooden%20table%20with%20warm%20sunlight%20and%20cherry%20blossoms%2C%20heartwarming%20golden%20tones%2C%20detailed%20illustration&width=800&height=500&seq=review-03&orientation=landscape",
  },
  {
    id: "rv-4",
    title: "机甲题材的又一高峰：《机械之心重启》观感解析",
    date: "2026-08-03",
    category: "作品解析",
    readTime: "10 分钟",
    excerpt: "当冰冷的机械遇上炙热的记忆，本作用细腻的演出重新定义了「人与机器」的关系，堪称本季机甲题材的最大惊喜。",
    image: "https://readdy.ai/api/search-image?query=anime%20mecha%20review%20banner%20of%20a%20white%20and%20red%20robot%20in%20a%20hangar%20with%20glowing%20lights%2C%20sci-fi%20cinematic%20atmosphere%2C%20teal%20and%20crimson%20accents%2C%20detailed%20illustration&width=800&height=500&seq=review-04&orientation=landscape",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "本站提供动画或资源的下载吗？",
    a: "不提供。漫镜 ACG 是一站式的动漫资讯门户，仅提供新番情报、评分榜单、观后评测与作品资料等内容。所有作品请前往各大正版平台观看与支持，这样才有更多好作品诞生。",
  },
  {
    q: "如何快速找到自己感兴趣的作品？",
    a: "你可以使用顶部搜索框直接输入作品名称，或通过「主题分类」板块按热血、治愈、奇幻等类型浏览。每个分类都会持续更新推荐作品与评分，帮助你高效选番。",
  },
  {
    q: "高分榜的评分依据是什么？",
    a: "评分综合了站内编辑评测与主流观众口碑，采用 0–10 分制。高分榜按月更新，重点收录经过时间检验、口碑稳定的优秀作品，避免随热度大起大落。",
  },
  {
    q: "新番速递多久更新一次？",
    a: "每个新番档期（冬、春、夏、秋）开播前我们会发布完整的追番清单，开播后每周更新评分与新作资讯，确保信息及时准确。",
  },
  {
    q: "我可以在本站投稿评测或推荐作品吗？",
    a: "当然可以。欢迎通过页面底部的联系方式给我们投稿，经编辑审核后会发布在「最新评测」栏目，并标注作者信息。你的每一条分享都会被认真对待。",
  },
  {
    q: "网站内容是否免费？",
    a: "漫镜 ACG 的所有资讯、榜单与评测均免费开放浏览。我们坚持用真实、客观的内容服务每一位动漫爱好者，不设付费墙。",
  },
];

export const heroStats = [
  { value: "1200+", label: "收录作品" },
  { value: "86%", label: "追番用户活跃" },
  { value: "8.9", label: "平均评分" },
  { value: "30+", label: "每周更新情报" },
];